import React from 'react';

const steps = [
  {
    number: '01',
    title: 'We get to know you',
    text: 'Tell us about your people, your plans and all the little things that make this celebration unmistakably yours.',
  },
  {
    number: '02',
    title: 'You live every moment',
    text: 'We offer gentle direction when you need it and plenty of quiet space when you don’t — the day stays yours.',
  },
  {
    number: '03',
    title: 'You get to feel it again',
    text: 'A thoughtfully curated gallery, delivered with care, made to bring you right back for years to come.',
  },
];

function Process() {
  return (
    <section className="process section-wrap" id="process">
      <div className="section-head">
        <div>
          <span className="eyebrow">06 / The experience</span>
          <h2>Easy from the first<br /><em>hello to the last dance.</em></h2>
        </div>
        <p>No timelines written in stone, no stiff poses — just a calm, considered process built around you.</p>
      </div>
      <div className="process-steps">
        {steps.map((step) => (
          <div className="process-step" key={step.number}>
            <span>{step.number} / 03</span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Process;
